import { z } from 'zod';

export const profitCreateSchema = z.object({
  profit: z.object({
    profit_value: z
      .number({ error: '売上金額は必須です' })
      .int('売上金額は整数で入力してください')
      .nonnegative('売上金額は0以上で入力してください'),
    entry_expect_date: z.string().min(1, '入社予定日は必須です'),
    payment_date: z.string().optional().or(z.literal('')),
    memo: z.string().max(1000, 'メモは1000文字以内で入力してください').optional().or(z.literal('')),
    organization_user_id: z.number({ error: '担当者は必須です' }).int(),
    job_change_process_id: z.number({ error: '選考プロセスは必須です' }).int(),
  }),
});

export const profitUpdateSchema = z.object({
  profit: z.object({
    profit_value: z
      .number({ error: '売上金額は必須です' })
      .int('売上金額は整数で入力してください')
      .nonnegative('売上金額は0以上で入力してください'),
    entry_expect_date: z.string().min(1, '入社予定日は必須です'),
    payment_date: z.string().optional().or(z.literal('')),
    refund_date: z.string().optional().or(z.literal('')),
    memo: z.string().max(1000, 'メモは1000文字以内で入力してください').optional().or(z.literal('')),
    organization_user_id: z.number({ error: '担当者は必須です' }).int(),
  }),
});

export type ProfitCreateInput = z.infer<typeof profitCreateSchema>;
export type ProfitUpdateInput = z.infer<typeof profitUpdateSchema>;
